import React, { Suspense } from "react";
import { Container } from "../container";
import { Card } from "./card";
import { PrettyPrint } from "../prettyprint";

export const CardList: React.FC<{
  title?: string | null;
  items: Link[];
  mainItem?: Link;
  textBlock?: {
    readonly data: {
      readonly text_block: string;
    } | null;
  } | null;
  columns?: number;
  showDividerAndTitle?: boolean;
}> = ({
  title,
  items,
  textBlock,
  mainItem,
  columns = 4,
  showDividerAndTitle = true,
  ...props
}) => {
  const colsClass = columns === 5 ? "lg:grid-cols-5" : "lg:grid-cols-4";
  showDividerAndTitle = items.length > 1 && showDividerAndTitle;
  console.log({ textBlock });
  return (
    <div className={showDividerAndTitle ? "" : "mt-5"} {...props}>
      {showDividerAndTitle && title && (
        <div className="relative top-[1px] mt-5 flex w-full">
          <div className="flex-1 "></div>
          <Container>
            <div className="flex justify-end">
              <div className="rounded-l-2xl border-b border-l border-t border-beige pl-8 text-base">
                {title}
              </div>
            </div>
          </Container>
          <div className="relative flex-1">
            <div className="absolute -left-12 bottom-0 right-0 top-0 border-b border-t border-beige"></div>
          </div>
        </div>
      )}
      <div
        className={` ${
          showDividerAndTitle ? "border-b border-t border-beige pb-8 pt-8" : ""
        }`}
      >
        {/* <Container>
          <PrettyPrint obj={items} />
        </Container> */}
        <Container className={`grid gap-16 ${colsClass}`}>
          {!mainItem && !textBlock && items.length < 3 && (
            <div className="col-span-1 " />
          )}
          {mainItem && <Card wide high {...mainItem} />}
          {!mainItem && textBlock?.data?.text_block && (
            <Card wide noImage external={false}>
              <div
                className="markdown px-6 py-4 text-base lg:text-lg"
                dangerouslySetInnerHTML={{
                  __html: textBlock?.data?.text_block,
                }}
              />
            </Card>
          )}
          {items.map((item, i) => {
            if (!item) return;
            return (
              <Card
                i={
                  !(mainItem || textBlock) && items.length < 3
                    ? i + 1
                    : (mainItem || textBlock) && i < 2
                    ? i + 2
                    : i
                }
                columns={columns}
                {...item}
                key={item.id ? `card-${item.id}` : `card-${i}-${item.title}`}
              />
            );
          })}
          {mainItem && items.length < 3 && (
            <>
              <Card spacer /> <Card spacer />
            </>
          )}
        </Container>
      </div>
    </div>
  );
};
